import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { FadeUp } from "@/components/Reveal";

const Counter = ({ to, suffix = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, to, {
      duration: 1.8,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setVal(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, to]);

  return (
    <span ref={ref} className="tabular-nums">
      {val}
      {suffix}
    </span>
  );
};

const STATS = [
  { value: 9, suffix: "", label: "Practice Areas" },
  { value: 15, suffix: "+", label: "Corporate Clients" },
  { value: 10, suffix: "M", label: "Indemnity Cover (KShs)" },
  { value: 8, suffix: "+", label: "Years in Practice" },
];

export default function StatsStrip() {
  return (
    <section
      data-testid="stats-strip"
      className="relative border-y border-gold/15 bg-navy-900/40"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12 grid grid-cols-2 lg:grid-cols-4 gap-8">
        {STATS.map((s, i) => (
          <FadeUp key={s.label} delay={i * 0.08} className="text-center">
            <div
              className="font-display text-4xl lg:text-5xl text-gold"
              data-testid={`stat-value-${i}`}
            >
              <Counter to={s.value} suffix={s.suffix} />
            </div>
            <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-ink-muted mt-2">
              {s.label}
            </div>
          </FadeUp>
        ))}
      </div>
    </section>
  );
}
